import { Trans } from '@onshape/www-inertia';

declare module 'vue' {
  interface ComponentCustomProperties {
    $t: (_en: string, _key: string, _label?: string) => string;
  }
}

export default defineNuxtPlugin({
  name: '$t',
  setup(nuxtApp) {
    const $t = (en: string, key: string, label?: string) => {
      if (label) return label;
      return Trans.by(en, key);
    };

    nuxtApp.vueApp.config.globalProperties.$t = $t;
    return {
      provide: {
        $t,
      },
    };
  },
});
